








import { Component, Vue } from 'vue-property-decorator';
import PvglWrap from './components/PvglWrap.vue';
import { Position, WidgetType } from './models/Enums';
import Timeout = NodeJS.Timeout;

@Component({
  components: {
    PvglWrap,
  },
})
export default class App extends Vue {
  /* tslint:disable */
  private pk: string = (window as any).dkVars.pk;
  /* tslint:enable */
  private Amazon: WidgetType = WidgetType.Amazon;
  private Idealo: WidgetType = WidgetType.Idealo;
  private Cameras: WidgetType = WidgetType.Cameras;
  private LocalShop: WidgetType = WidgetType.LocalShop;
  private activePosition!: Position;
  private type!: WidgetType;
  private loaded = false;
  private key = 1;
  private resizeFunc = this.debounce(this.onResize, 100);

  public beforeCreate() {
    this.activePosition = (this.$root as any).activePosition;
    this.type = (this.$root as any).type;
  }
  public updated() {
    this.$nextTick(() => {
      for (const link of this.$el.getElementsByTagName('a')) {
        link.addEventListener('click', this.trackOutboundLink);
      }
    });
  }
  public mounted() {
    window.addEventListener('resize', this.resizeFunc);
  }
  public beforeDestroy() {
    window.removeEventListener('resize', this.resizeFunc);
  }
  private debounce<T extends Function>(cb: T, wait = 20) {
    let h: number = 0;
    let callable = (...args: any) => {
      clearTimeout(h);
      h = (setTimeout(() => cb(...args), wait) as unknown) as number;
    };
    return <T>(<any>callable);
  }

  private onResize() {
    console.log('window has been resized', this.$root.$el);
    const vueParent = this.$root.$el.parentElement;
    if (vueParent != null) {
      console.log(vueParent.clientWidth);
      let oldPosition = this.activePosition;
      if (vueParent.clientWidth < 666) {
        this.activePosition = Position.Side;
      } else if (vueParent.clientWidth >= 666) {
        this.activePosition = Position.Center;
      }
      if (oldPosition !== this.activePosition) {
        this.key = this.key + 1;
      }
    }
  }
  private trackOutboundLink(e: MouseEvent) {
    if (e.currentTarget) {
      if (e.currentTarget instanceof HTMLAnchorElement) {
        this.sendToGa(e.currentTarget.href);
      } else if (e.currentTarget instanceof Node && e.currentTarget.parentElement instanceof HTMLAnchorElement) {
        this.sendToGa(e.currentTarget.parentElement.href);
      }
    }
  }
  private sendToGa(href: string) {
    // console.info(`sending ${this.type} with ${href} to GA`);
    if ((window as any).ga) {
      (window as any).ga('send', 'event', 'Widget', this.type, href);
    }
  }
}
